import {
    EntityCustomFieldValueView,
    OpportunityBidCategoryView,
    OpportunityBuildingContactRoleView,
    OpportunityBuildingView,
    OpportunityChangeOrderEstimateView,
    OpportunityCompanyView,
    OpportunityContactView,
    OpportunityEstimateView,
    OpportunityMarketView,
    OpportunityProductTypeView,
    OpportunityStatusHistoryView,
    OpportunityTagView,
    OpportunityUserFavoriteView,
    OpportunityUserView,
    OpportunityView
} from '@api-proxies';
import { ModelBase } from './ModelBase';

export class Opportunity extends ModelBase implements OpportunityView {
    static fromInterface(dto: OpportunityView): Opportunity {
        const opportunity = new Opportunity();
        opportunity.mapFromInterface(dto);
        return opportunity;
    }

    organizationId: number | undefined = undefined;
    name: string | undefined = '';
    projectId: string | undefined = '';
    description: string | undefined = '';
    divisionId: number | undefined = undefined;
    dueDate: Date | undefined = undefined;
    expectedResponseDate: Date | undefined = undefined;
    projectStart: Date | undefined = undefined;
    projectEnd: Date | undefined = undefined;
    bidDate: Date | undefined = undefined;
    awardedDate: Date | undefined = undefined;
    actualValue: number | undefined = undefined;
    actualGrossMarginPercentage: number | undefined = undefined;
    actualGrossMarginAmount: number | undefined = undefined;
    opportunityValue: number | undefined = undefined;
    potentialValue: number | undefined = undefined;
    proposedGrossMarginPercentage: number | undefined = undefined;
    proposedGrossMarginAmount: number | undefined = undefined;
    potentialNumberOfTerms: number | undefined = undefined;
    potentialTermAverage: number | undefined = undefined;
    bidStatusId: number | undefined = 0;
    opportunityStatusId = 0;
    opportunityProbabilityId: number | undefined = undefined;
    companyId: number | undefined = undefined;
    buildingId: number | undefined = undefined;
    buildingAddressId: number | undefined = undefined;
    leadSourceId: number | undefined = undefined;
    createdByUserId: number | undefined = undefined;
    isActive = false;
    organizationName: string | undefined = '';
    divisionName: string | undefined = '';
    opportunityStatusName: string | undefined = '';
    probabilityValue: number | undefined = undefined;
    probabilityName: string | undefined = '';
    companyName: string | undefined = '';
    companyCityName: string | undefined = '';
    companyCountryName: string | undefined = '';
    companyStateName: string | undefined = '';
    companyZipCode: string | undefined = '';
    companyContactPhone: string[] | undefined = undefined;
    buildingName: string | undefined = '';
    buildingSize: number | undefined = undefined;
    buildingFloorSize: number | undefined = undefined;
    addressId: number | undefined = undefined;
    line1: string | undefined = '';
    line2: string | undefined = '';
    latitude: number | undefined = undefined;
    longitude: number | undefined = undefined;
    zipCode: string | undefined = '';
    countryId: number | undefined = undefined;
    stateId: number | undefined = undefined;
    cityId: number | undefined = undefined;
    countryName: string | undefined = '';
    stateName: string | undefined = '';
    cityName: string | undefined = '';
    fullAddress: string | undefined = '';
    salesUsers: string | undefined = '';
    companyLine1: string | undefined = '';
    companyLine2: string | undefined = '';
    salesUsersCount: number | undefined = undefined;
    baseEstimateId: number | undefined = undefined;
    leadSourceName: string | undefined = '';
    contactEmail: string[] | undefined = [];
    contactPhone: string[] | undefined = [];
    contactFullName: string | undefined = '';
    leadSourceExternalId: string | undefined = undefined;
    organizationCode: string | undefined = '';
    baseEstimateExternalUrl: string | undefined = undefined;
    opportunityBidCategories: OpportunityBidCategoryView[] | undefined = [];
    opportunityBuildingContactRoles: OpportunityBuildingContactRoleView[] | undefined = [];
    opportunityBuildings: OpportunityBuildingView[] | undefined;
    opportunityChangeOrderEstimates: OpportunityChangeOrderEstimateView[] | undefined = [];
    opportunityContacts: OpportunityContactView[] | undefined = [];
    opportunityCompanies: OpportunityCompanyView[] | undefined = [];
    opportunityEstimates: OpportunityEstimateView[] | undefined = [];
    opportunityMarkets: OpportunityMarketView[] | undefined = [];
    opportunityProductTypes: OpportunityProductTypeView[] | undefined = [];
    opportunityStatusHistories: OpportunityStatusHistoryView[] | undefined = [];
    opportunityTags: OpportunityTagView[] | undefined = [];
    opportunityUserFavorites: OpportunityUserFavoriteView[] | undefined = [];
    opportunityUsers: OpportunityUserView[] | undefined = [];
    opportunitySalespersons: OpportunityUserView[] | undefined = [];
    customFieldValues: EntityCustomFieldValueView[] | undefined = [];
    companyCountryCode: string | undefined = undefined;
    companyStateCode: string | undefined = undefined;
    countryCode: string | undefined = undefined;
    stateCode: string | undefined = undefined;
    addressLines: string | undefined = undefined;
    companyAddressLines: string | undefined = undefined;
    projectDuration: number | undefined = undefined;
    opportunityManualId: number | undefined = undefined;
    companyNames: string | undefined = undefined;
    companyRoleNames: string | undefined = undefined;
    divisionIsActive: boolean | undefined = true;
    buildingIsActive: boolean | undefined = true;
    acumaticaBidUrl: string | undefined = undefined;

    isValidName() {
        return !!this.name;
    }
}
